import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import "../../assets/styles/Sidebar.css";
import routes from '../../routes';
import { getUserName, logout } from '../../services/auth';

export default function SideBar() {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const user = getUserName();

    const routesPermitidas = routes.filter(route =>
        !(route.restritoPara?.includes(user))
    );

    return (
        <div className="sidebar">
            <div className="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100">
                <a href="/" className="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-white text-decoration-none">
                    <img
                        src={require("../../assets/img/brand/logo.png")}
                        alt="Logo"
                        className='sidebar-logo'
                    />
                </a>
                <ul className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start mt-3" id="menu">
                    {routesPermitidas.map((item, index) => (
                        <li key={index} className="nav-item">
                            <Link to={item.route} className="nav-link align-middle px-0 text-white">
                                <i className={`fs-6 bi ${item.icon} text-white`} />
                                <span className="ms-3 d-none d-sm-inline text-white">{item.name}</span>
                            </Link>
                        </li>
                    ))}

                </ul>
                <hr />
                {/* <div className="mt-auto w-100 my-2">
                    <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)} className="w-100">
                        <DropdownToggle caret className="user-section d-flex align-items-center text-white px-3 py-2 w-100">
                            <i className="bi bi-person-circle fs-5"></i>
                            <span className="ms-2 flex-grow-1 text-start text-user text-truncate" style={{ maxWidth: "150px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {user}
                            </span>
                        </DropdownToggle>
                        <DropdownMenu className="w-100 text-center">
                            <DropdownItem onClick={() => logout()}>Sair</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div> */}
            </div>
        </div>
    );
}
